import { render, staticRenderFns } from "./LoanType.vue?vue&type=template&id=6aba936c"
import script from "./LoanType.vue?vue&type=script&lang=js"
export * from "./LoanType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports